var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 14 14.4 2.3C13.5.9 12.4 0 11 0 9.7 0 8.5.8 7.6 2.4L1.2 13.9c-.8 1.5-.9 2.9-.2 4 .6 1.1 2 1.7 3.6 1.7h12.8c1.7 0 3-.6 3.6-1.7.7-1.1.6-2.5-.2-4ZM10.3 7c0-.4.3-.8.7-.8.4 0 .8.4.8.8v5c0 .4-.4.8-.8.8a.8.8 0 0 1-.7-.8V7Zm1.4 8.7-.1.1-.2.1h-.2l-.2.1h-.4l-.2-.2h-.1a1 1 0 0 1-.3-.8c0-.3.1-.5.3-.7l.1-.1.2-.1h.2c.1-.1.3-.1.4 0h.4l.1.2c.2.2.3.4.3.7 0 .3-.1.5-.3.7Z",
    fill: "#E61919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcon);
export default __webpack_public_path__ + "static/media/inputIcon.79bc95cfee4b539ad436674d6b22d363.svg";
export { ForwardRef as ReactComponent };